var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isSpanBySpan)?_c('img',{attrs:{"src":require("./loads--isSpanBySpan.png"),"alt":"Loads Distributed Span By Span"}}):_c('img',{attrs:{"src":require("./loads--isntSpanBySpan.png"),"alt":"Loads Distributed"}})])}
var staticRenderFns = []

export { render, staticRenderFns }